import { render, staticRenderFns } from "./ozon.vue?vue&type=template&id=64a443d8&"
import script from "./ozon.vue?vue&type=script&lang=js&"
export * from "./ozon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports